import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=09b4c5b8&scoped=true"
import script from "./contentDetail.vue?vue&type=script&lang=js"
export * from "./contentDetail.vue?vue&type=script&lang=js"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=09b4c5b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4c5b8",
  null
  
)

export default component.exports